import styled from 'styled-components/macro';

export const IconWrapper = styled.div`
  margin-bottom: 0.35rem;
  margin-left: ${({ theme }) => theme.spacing.zero_1};

  transform: rotate(180deg);
  cursor: pointer;
`;
